import Select from '@/library/components/form/inputs/select';
import { TableFilterSelectorProps } from '@/common/types/front-entities/table';

type AiFieldOption = { value: string; label: string };

type InvoiceFieldNameSelectorProps = TableFilterSelectorProps & {
  options?: AiFieldOption[];
};

function InvoiceFieldNameSelector({
  isMulti = true,
  value,
  label,
  onChange,
  placeholder,
  options
}: InvoiceFieldNameSelectorProps) {
  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select field'}
      getOptionValue={option => option.value}
      getOptionLabel={option => option.label}
      value={value}
      options={options}
      isMulti={isMulti}
      onChange={selected => onChange(selected)}
      isClearable
    />
  );
}

export default InvoiceFieldNameSelector;
